import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { LexicalEditor } from "lexical";
import { useEffect } from "react";
import { $generateHtmlFromNodes } from "@lexical/html";
import { mergeRegister } from "@lexical/utils";

interface CustomOnChangePluginProps {
  onChange?: (value: Record<"json" | "html", string>) => void;
}

export default function CustomOnChangePlugin({
  onChange,
}: CustomOnChangePluginProps) {
  const [editor] = useLexicalComposerContext();

  function handleChange(editor: LexicalEditor) {
    const editorState = editor.getEditorState();
    const json = editorState.toJSON();
    const jsonString = JSON.stringify(json);
    const htmlString = $generateHtmlFromNodes(editor);
    onChange?.({
      json: jsonString,
      html: htmlString,
    });
  }

  useEffect(() => {
    if (!editor) {
      return;
    }
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          handleChange(editor);
        });
      })
    );
  }, [editor, onChange]);

  return null;
}
